import React from 'react';
import InputMask from 'react-input-mask';
import { TextField } from '@mui/material';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import BudgetSection from './BudgetSection';
import { roundedFieldSx } from './budgetFormat';
import sectionStyles from './BudgetSection.module.css';

/** Dados de quem recebe o orçamento (nome, CPF, telefone e e-mail). */
function BudgetCustomerForm({ customer, onChange }) {
  return (
    <BudgetSection
      icon={<PersonOutlineRoundedIcon />}
      title="Dados do interessado"
      subtitle="Aparecem no PDF. Todos são opcionais."
    >
      <div className={sectionStyles.fieldGrid}>
        <TextField
          label="Nome"
          size="small"
          fullWidth
          sx={roundedFieldSx}
          value={customer.name}
          onChange={(e) => onChange('name', e.target.value)}
        />

        <InputMask
          mask="999.999.999-99"
          value={customer.cpf}
          onChange={(e) => onChange('cpf', e.target.value)}
        >
          {(inputProps) => (
            <TextField {...inputProps} label="CPF" size="small" fullWidth sx={roundedFieldSx} />
          )}
        </InputMask>

        <InputMask
          mask="(99) 99999-9999"
          value={customer.phone}
          onChange={(e) => onChange('phone', e.target.value)}
        >
          {(inputProps) => (
            <TextField {...inputProps} label="Telefone" size="small" fullWidth sx={roundedFieldSx} />
          )}
        </InputMask>

        <TextField
          label="E-mail"
          size="small"
          fullWidth
          type="email"
          sx={roundedFieldSx}
          value={customer.email}
          onChange={(e) => onChange('email', e.target.value)}
        />
      </div>
    </BudgetSection>
  );
}

export default BudgetCustomerForm;
